import React from 'react';
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import RoomServiceIcon from '@material-ui/icons/RoomService';
import { IoFunnelSharp } from 'react-icons/io5';
import { MenuDish } from '../constants/type.constant';
import { MenuDetailInfo } from '../components/menu-detail-info';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import RemoveIcon from '@material-ui/icons/Remove';
import _ from 'lodash';
import Store from '../redux/store';
import { StateManager } from '../redux/stateManager';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { isIphonex, PHONE_TYPE, preLoadNginxImage } from '../tools/utils';
import foodDefaultImage from '../assets/food.png';
import RestoreOutlinedIcon from '@material-ui/icons/RestoreOutlined';
import i18n from '../i18n';
import ServerShoppingCart from '../modules/server-shopping-cart';
const bargainIcon = require('../assets/bargain-icons/QOP-bargain-icon.png');
const allergenFilterIcon = require('../assets/allergen-filter-icon/QOP-allergen-filter-icon.png');

// 加入或移出购物车
enum UPGRADE {
    REMOVE_DISH = -1,
    ADD_DISH = 1,
}

// 菜品大图详细信息
export default class FoodDetailInfo extends React.PureComponent<Props, State>{
    public descriptRef: HTMLDivElement | null = null;
    public isDescriptHeight: boolean = false;
    public detailBottomRef: HTMLDivElement | null = null;
    public BOTTOM_HEIGHT: number = 1;
    // 货币符号
    currency_name: string = '€';
    constructor(props: Props) {
        super(props);
        this.state = {
            // 是否打开菜品详细信息
            isOpenDescript: false,
            // 卡片大图详情底部区域高度
            bottomHeight: 0,
            //
            dishImg: ``,
            // 是否需要显示详情省略按钮
            isDescriptHeight: false,
        }
        this.currency_name = StateManager.getFromCache('currency_name') || '€';
    }
    // *********************
    // 生命周期
    // *********************
    public async UNSAFE_componentWillMount() {
        await this.preloadImage();
        const findRes = this.getSettingInfoValue('show-item-name1-or-item-name2')
        if (findRes) this.isShowName1 = findRes.value.showItemName1
    }
    public componentDidMount() {
    }

    public async componentWillUnmount() {
        // $ alwyas unsubscribe in un mount function
    }

    // *********************
    // 方法区
    // *********************
    public isShowName1 = true;
    public getSettingInfoValue(str: string) {
        const SETTING = StateManager.getFromCache('settingInfo');
        return _.find(SETTING, ['name', str]);
    }

    async preloadImage() {
        let dishImg = `${Store.getState().serverUrl}/menu_pic/${this.props.item?.item_id}.jpg`;
        const newImage = await  preLoadNginxImage(dishImg, '/menu_pic', '', true);
        this.setState({
            dishImg: newImage || foodDefaultImage
        })
    }

    /**
     * 设置“省略”按钮
     */
    setOmitButton() {
        if (this.descriptRef) {
            const descriptOffsetHeight = _.get(this.descriptRef, 'offsetHeight')
            // 根据行高计算，是否显示‘文本展示按钮’
            console.log(descriptOffsetHeight);
            if (descriptOffsetHeight) {
                if (descriptOffsetHeight >= 73) this.isDescriptHeight = true;
            }
        }
    }

    /**
     * 查看菜品详细文本信息
     */
    public openDescript() {

    }

    // 关闭菜品大图
    closeMenuDetail = () => {
        this.props.updateValue({
            foodDetailVisible: false
        })
    }

    /**
     * 获取详情 ref
     * @param descRef 
     * @returns 
     */
    getDescRef = (descRef: any) => {
        this.descriptRef = descRef;
        const descriptOffsetHeight = _.get(this.descriptRef, 'offsetHeight')
        // 根据行高计算，是否显示‘文本展示按钮’
        if (descriptOffsetHeight && !this.state.isDescriptHeight) {
            if (descriptOffsetHeight >= 97) {
                this.setState({
                    isDescriptHeight: true
                })
            }
        }
    }

    // 其他菜品标识
    public renderPage = (item: MenuDish) => {
        return (
            <React.Fragment>
                <div className="buttonImg">
                    <div className="detailInfo">
                        {
                            item.other_detail_info.map((condimentItem, index) => (
                                <div className="condimentItem" key={index}>

                                    <MenuDetailInfo imgPath={condimentItem} />
                                </div>
                            ))
                        }
                    </div>
                    <div className="detailInfo">
                        {
                            item.allergen.map((allergyItem, index) => (
                                <div className="condimentItem" key={index}>
                                    <MenuDetailInfo imgPath={allergyItem} />
                                </div>

                            ))
                        }
                    </div>
                </div>
            </React.Fragment>
        )
    }

    public countHeight() {
        // 获取底部区域高度
        const BOTTOM_HEIGHT = _.get(this.detailBottomRef, 'offsetHeight');

        // 机型判断
        if (BOTTOM_HEIGHT) {
            if (isIphonex()) {
                if (PHONE_TYPE.indexOf('iPhone') > -1 && PHONE_TYPE.indexOf('Safari') > -1) this.BOTTOM_HEIGHT = BOTTOM_HEIGHT + 120;
                else this.BOTTOM_HEIGHT = BOTTOM_HEIGHT;
            }
            else {
                if (PHONE_TYPE.indexOf('iPhone') > -1 && PHONE_TYPE.indexOf('Safari') > -1) this.BOTTOM_HEIGHT = BOTTOM_HEIGHT + 70;
                else this.BOTTOM_HEIGHT = BOTTOM_HEIGHT;
            }
        }

        if (this.detailBottomRef) {
            return `calc(100% - ${this.BOTTOM_HEIGHT}px)`;
        }
        return `calc(100% - ${this.BOTTOM_HEIGHT}px)`;
    }

    // *********************
    // 视图区
    // *********************
    public render() {
        const { item } = this.props;
        const { isOpenDescript, isDescriptHeight } = this.state;

        // 历史数量
        const historyQuantity = item.history_num || 0;
        // 套餐
        const isSetMenu = item.item_type === 3;
        // isBusinessTime 为true则不在营业时间内
        const isBusinessTime = Store.getState().isBusinessTime;
        // 过敏原 & 菜品标识过滤器标识
        const filterFlag: boolean = ServerShoppingCart.getAllergensAndIngredentsFilterFlag(item);
        // 是否为沽清菜品
        const isBargainDish = [1, 3].includes(Number(item.bargain_stype)) || (Number(item.bargain_stype) === 2 && typeof(item.bargain_num_cur) !== 'number');
        return (
            <div className="swiper-slide" id='swiper-slide-detail' style={{ width: '100%' }}>
                {/* 菜品沽清 */}
                {
                    (isBargainDish || filterFlag) ?
                    <div className='bargainStype'>
                        {
                            isBargainDish ? 
                                <div className='mask-icon-box'>
                                    {/* <RoomServiceIcon />
                                    <CloseIcon className=' bargain-icon' /> */}
                                    <img src={bargainIcon} />
                                </div>
                                :
                                null
                        }
                        {filterFlag && <div className='mask-icon-box'><img src={allergenFilterIcon} /></div>}
                    </div>
                    :
                    null
                }     
                {
                    isOpenDescript ?
                        <div className="closeIcon" onClick={() => { this.setState({ isOpenDescript: false }) }}>
                            <ChevronLeftIcon className="overall-center" style={{ fontSize: 16 }}></ChevronLeftIcon>
                        </div>
                        :
                        <div className="closeIcon" onClick={this.closeMenuDetail}>
                            <CloseIcon className="overall-center" style={{ fontSize: 14 }}></CloseIcon>
                        </div>
                }                             
                <div className={`${item.quantity > 0 && !isSetMenu ? 'box active' : 'box'}`}>
                    <div className="bottom">
                        {/* 样式适配：底部区域高度计算 */}
                        <div style={isOpenDescript ?
                            { overflow: 'auto' } :
                            item.other_detail_info.length && item.allergen.length ? {
                                overflow: 'auto',
                                height: this.countHeight()
                            } :
                                {
                                    overflow: 'auto',
                                    height: this.countHeight(),
                                    // display: 'flex',
                                    // flexDirection: 'column',
                                    // justifyContent: 'space-between',
                                    // paddingBottom: 25
                                }
                        }>
                            <div className="left">
                                
                                <h3 className="title">{this.isShowName1 ? item.item_name1 : item.item_name2}</h3>
                                {/* 不显示，用作与计算高度，是否显示省略按钮 */}
                                <p
                                    ref={this.getDescRef}
                                    // className={'shrink'}
                                    style={{ wordWrap: 'break-word', lineHeight: '24px', position: 'absolute', zIndex: -1, opacity: 0, left: 20, right: 20 }}>
                                    {item.ext_dish_info} {item.item_description}
                                </p>
                                {/* 显示文本 */}
                                <p
                                    className={!isOpenDescript ? 'desc' : 'shrink'}
                                    style={{ wordWrap: 'break-word', lineHeight: '24px' }}>
                                    {item.ext_dish_info} {item.item_description}
                                </p>
                                {
                                    isDescriptHeight && !isOpenDescript &&
                                    <div style={{ width: 32, height: 32, marginBottom: 5 }}>
                                        <Button
                                            style={{
                                                backgroundColor: '#ffffff2e',
                                                minWidth: '100%',
                                                fontSize: 16,
                                                fontWeight: 'bold',
                                                width: 32, height: 32,
                                                padding: 0
                                            }}
                                            onClick={() => this.setState({ isOpenDescript: !isOpenDescript })}
                                        >
                                            ···
                                        </Button>
                                    </div>
                                }
                                {
                                    !isOpenDescript && <div className="price">{item.price_1.toFixed(2)} {this.currency_name}</div>
                                }
                                {/* 曾经点过菜 */}
                                {
                                    historyQuantity
                                        ? <div className='swiper-slide-history-icon-box'>
                                            <RestoreOutlinedIcon className='swiper-slide-history-icon' />
                                            <span className='swiper-slide-history-text'>{i18n.t('general_text_ordered')} {historyQuantity}</span>
                                        </div> : null
                                }
                            </div>

                            {/* 大图 */}
                            {
                                !isOpenDescript &&

                                <div
                                    style={{
                                        background: `url(${this.state.dishImg})  no-repeat center center /113%`,
                                        height: '32vh',
                                    }} />
                            }
                        </div>
                        {
                            !isOpenDescript &&
                            <div className="detailBottom"
                                ref={(detailBottomRef) => {
                                    this.detailBottomRef = detailBottomRef;
                                }}>
                                {this.renderPage(item)}
                                {/* 菜品沽清 */}
                                {
                                    (isBargainDish || filterFlag) ?
                                        <div className='bargainStype'></div>
                                        :
                                        null
                                }
                                {/* 营业时间规则的限制 */}
                                {
                                    isBusinessTime && item.not_joining_global_limit !== 1 &&
                                    <div className='businessTimeStype'></div>
                                }
                                {/* 区分精简版和普通版 */}
                                {
                                    this.props.liteMode ?
                                        <Grid style={{ background: '#fff' }}></Grid> :
                                        isSetMenu ?
                                            <Grid
                                                container
                                                spacing={0}
                                                className="footer"
                                                style={(isBusinessTime && item.not_joining_global_limit !== 1) ? { background: '#007993' } : {}}>
                                                <Grid item xs={12} >
                                                    <Button
                                                        fullWidth
                                                        className="icon alignLeft"
                                                        onClick={() => {
                                                            this.props?.openSetDishDetail?.();
                                                        }}
                                                    // disabled={item.quantity === 0}
                                                    >
                                                        {/* // TODO 国际化 */}
                                                        {i18n.t('Order')}
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                            :
                                            <Grid
                                                container
                                                spacing={0}
                                                className="footer"
                                                style={(isBusinessTime && item.not_joining_global_limit !== 1) ? { background: '#007993' } : {}}>
                                                <Grid item xs={4}>
                                                    <Button
                                                        fullWidth
                                                        className="icon alignLeft"
                                                        onClick={() => {
                                                            this.props.changeMenuQuantity(item, UPGRADE.REMOVE_DISH)
                                                        }}
                                                        disabled={item.quantity === 0}
                                                    >
                                                        <RemoveIcon></RemoveIcon>
                                                    </Button>
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <div className="num">
                                                        {/* {Store.getState().isShowTime ? item.quantity + (item.history_num || 0) : item.quantity} */}
                                                        {/* 一直显示历史数量+当前数量 */}
                                                        {item.quantity + (item.history_num || 0)}
                                                    </div>
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <Button
                                                        fullWidth
                                                        className="icon alignRight"
                                                        onClick={() => this.props.changeMenuQuantity(item, UPGRADE.ADD_DISH)}
                                                    >
                                                        <AddIcon></AddIcon>
                                                    </Button>
                                                </Grid>

                                            </Grid>
                                }


                            </div>
                        }
                    </div>
                </div>

            </div >
        )
    }

}
type Props = {
    // 选中的二级菜单的菜品
    item: MenuDish & { history_num?: number }
    /**
     * 更新购物车
     * @param dish 菜品数据`Dish`
     * @param type 操作类型` UPGRADE_OPERATES`
     */
    changeMenuQuantity(dish: MenuDish, type: UPGRADE, expandDish?: MenuDish): void
    // 更新状态
    updateValue(val: any): void
    customer: string;
    // 判断手机型号
    isIphonex: boolean;
    // 精简版模式
    liteMode?: boolean;
    // 打开套餐
    openSetDishDetail?(): void;
}

type State = {
    isOpenDescript: boolean;
    // 卡片大图详情底部区域高度
    bottomHeight: number;
    dishImg: string;
    // 是否需要显示详情省略按钮
    isDescriptHeight: boolean;
}